import PrijavaSaPost from "../components/PrijavaSaPost";
import PrijavaBezPost from "../components/PrijavaBezPost";
import Drustvene from "../components/Drustvene";

function Pocetna() {
 return (
 <div className="container">
  <div className="pocetna-container mb-5">
    <div className="row">
      <h1>Prijava na event</h1>
      <p>Odaberi jednu od dvije opcije prijave:</p>
    </div>

    <div className="cards">
      <PrijavaSaPost />
      <PrijavaBezPost />
    </div>

  <div>
    <Drustvene />
</div>
  </div>
</div>

  );
}

export default Pocetna;
